import React, { useState, useEffect } from "react";
import axios from "axios";
import api from '../../api';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ETAPES_URL = "/parametrages/etapes";
const TICKETS_URL = "/tickets";

const AddTaskForm = ({ onClose }) => {
  const [nom, setNom] = useState("");
  const [content, setContent] = useState("");
  const [type, setType] = useState("bug");
  
  const [image, setImage] = useState(null);
  const [moduleId, setModuleId] = useState("");
  const [modules, setModules] = useState([]);
  const [etapes, setEtapes] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [emailSent, setEmailSent] = useState("");
  const [isLoading, setIsLoading] = useState(false); // État de chargement ajouté

  // États pour organisations
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [utilisateur_id, setUtilisateur_id] = useState(null);
  const [fonctionnelId, setFonctionnelId] = useState(null);

    useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setUtilisateur_id(parseInt(user.id, 10));
        setFonctionnelId(parseInt(user.id, 10));

      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);

  
  // Charger les organisations pour le fonctionnel
  useEffect(() => {
    api.get(`/organisations/fonctionnel/${fonctionnelId}`)
      .then(res => {
        const orgs = res.data.organisations || [];
        setOrganisations(orgs);
        if (orgs.length > 0) setSelectedOrg(orgs[0].id);
      })
      .catch(err => console.error('GET /organisations error:', err));
  }, [fonctionnelId]);

  // Charger les modules quand une organisation est sélectionnée
  useEffect(() => {
    if (!selectedOrg) return;
    api
      .get(`/organisations/${selectedOrg}`)
      .then(({ data }) => {
        setModules(data.organisation.modules || []);
        setEmailSent(data.organisation || "");
        setModuleId(""); // Reset module selection when org changes
      })
      .catch(err => console.error("Erreur fetch modules:", err));
  }, [selectedOrg]);

  // Charger les étapes
  useEffect(() => {
    api
      .get(ETAPES_URL)
      .then(res => {
        setEtapes(res.data.etapes || []);
      })
      .catch(err => console.error("Erreur fetch étapes:", err));
  }, []);

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "nom":
        if (value.length < 3) error = "Le nom doit contenir au moins 3 caractères";
        else if (value.length > 1000) error = "Le nom ne peut pas dépasser 1000 caractères";
        break;
      case "content":
        if (value.length > 1500) error = "La description ne peut pas dépasser 1500 caractères";
        break;
     
      case "moduleId":
        if (!value) error = "Veuillez sélectionner un module";
        break;
      default:
        break;
    }
    return error;
  };

  const isFutureDate = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const inputDate = new Date(dateString);
    return inputDate >= today;
  };

  useEffect(() => {
    const newErrors = {};
    Object.keys(touched).forEach((field) => {
      const value = { nom, content, moduleId }[field];
      const error = validateField(field, value);
      if (error) newErrors[field] = error;
    });
    setErrors(newErrors);
  }, [nom, content, moduleId, touched]);

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };


    const uploadToLaravel = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data.url; // URL publique renvoyée par Laravel
};
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalErrors = {
      nom: validateField("nom", nom),
      content: validateField("content", content),
     
      moduleId: validateField("moduleId", moduleId),
    };
    setErrors(finalErrors);
    if (Object.values(finalErrors).some(err => err)) return;
    if (!selectedOrg) {
      toast.error("Veuillez choisir un client");
      return;
    }
    let uploadedImageUrl = "";
          if (type === "bug" && image) {
            try {
              uploadedImageUrl = await uploadToLaravel(image);
            } catch (uploadErr) {
              console.error("Erreur upload Cloudinary :", uploadErr);
              toast.error("Erreur lors de l'upload de l'image");
              setIsLoading(false);
              return;
            }
          }

    setIsLoading(true); // Activer le loading

    const formData = new FormData();
    formData.append("nom", nom);
    formData.append("content", content);
    formData.append("type", type);
    
    formData.append("module_id", moduleId);
    formData.append("organisation_id", selectedOrg);
    formData.append("createur_id", utilisateur_id);
    formData.append("priorite", 1);
    formData.append("status", 1);
    formData.append("confirmation_admin", 0);
    formData.append("validation_adminCl", 1);
    formData.append("accepter", 3);
    formData.append("last_update", new Date().toISOString().split("T")[0]);
    formData.append("image", uploadedImageUrl);


    // Trouver l'étape d'ordre 1
    const premiereEtape = etapes.find(e => Number(e.order) === 1);
    if (premiereEtape) {
      formData.append("etape_id", premiereEtape.id);
    }



    try {
      await api.post(TICKETS_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Ticket créé avec succès !");
      console.log("Envoi des données :", formData);
      setTimeout(() => {
  if (onClose) onClose();
}, 1000);

    } catch (error) {
      if (error.response && error.response.status === 422) {
        console.log('Validation errors:', error.response.data.errors);
        console.log("Envoi des données :", formData);
      } else {
        console.log('Erreur:', error.message);
        console.log("Envoi des données :", formData);
      }
      toast.error("Erreur lors de la création du ticket");
    } finally {
      setIsLoading(false); // Désactiver le loading
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-sm shadow-2xl w-[90vw] max-w-2xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-1 hover:bg-gray-100 rounded-full transition-colors"
          disabled={isLoading}
        >
          <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h2 className="text-xl font-bold text-gray-800 mb-4">Nouveau Ticket</h2>

        {/* Overlay de chargement */}
        {isLoading && (
          <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-sm">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-terrecuite"></div>
              <p className="mt-2 text-sm text-gray-600">Création du ticket en cours...</p>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4" encType="multipart/form-data">
          {/* Choix du client */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">Client *</label>
            <select
              value={selectedOrg || ""}
              onChange={(e) => setSelectedOrg(Number(e.target.value))}
              disabled={isLoading}
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 text-sm ${
                isLoading ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
            >
              <option value="" disabled>Choisissez un client</option>
              {organisations.map(org => (
                <option key={org.id} value={org.id}>{org.nomOrganisation}</option>
              ))}
            </select>
          </div>

          {/* Module */}
          {selectedOrg && (
            <div>
              <label className="block text-sm text-gray-600 mb-1">Module *</label>
              <select
                value={moduleId}
                onChange={(e) => setModuleId(e.target.value)}
                onBlur={() => handleBlur("moduleId")}
                disabled={isLoading}
                className={`w-full px-3 py-2 border ${
                  errors.moduleId ? "border-red-500" : "border-gray-300"
                } rounded-md focus:ring-1 focus:ring-blue-500 text-sm ${
                  isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              >
                <option value="">-- Sélectionner un module --</option>
                {modules.map(mod => (
                  <option key={mod.id} value={mod.id}>{mod.nom}</option>
                ))}
              </select>
              {errors.moduleId && (
                <p className="text-red-500 text-xs mt-1">{errors.moduleId}</p>
              )}
            </div>
          )}

          {/* Nom + Type */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">Nom *</label>
              <input
                type="text"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                onBlur={() => handleBlur("nom")}
                disabled={isLoading}
                className={`w-full px-3 py-2 border ${
                  errors.nom ? "border-red-500" : "border-gray-300"
                } rounded-md focus:ring-1 focus:ring-blue-500 text-sm ${
                  isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              />
              {errors.nom && <p className="text-red-500 text-xs mt-1">{errors.nom}</p>}
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Type *</label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                disabled={isLoading}
                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 text-sm ${
                  isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              >
                <option value="bug">Bug</option>
                <option value="demande">Demande</option>
              </select>
            </div>
          </div>

         

          {/* Contenu */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">Description *</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              onBlur={() => handleBlur("content")}
              rows={3}
              disabled={isLoading}
              className={`w-full px-3 py-2 border ${
                errors.content ? "border-red-500" : "border-gray-300"
              } rounded-md focus:ring-1 focus:ring-blue-500 text-sm ${
                isLoading ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
            />
            {errors.content && <p className="text-red-500 text-xs mt-1">{errors.content}</p>}
            <div className="text-right text-xs text-gray-500 mt-1">{content.length}/1500 caractères</div>
          </div>

          {/* Image pour bugs */}
          {type === "bug" && (
            <div>
              <label className="block text-sm text-gray-600 mb-1">Capture d'écran</label>
              <label className={`flex items-center justify-center w-full border border-dashed border-gray-300 rounded-md p-2 text-sm cursor-pointer hover:border-blue-400 transition-colors ${
                isLoading ? "bg-gray-100 cursor-not-allowed hover:border-gray-300" : ""
              }`}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                  disabled={isLoading}
                  className="hidden"
                />
                <span className="text-gray-500">{image ? image.name : "Cliquez pour téléverser"}</span>
              </label>
            </div>
          )}

          {/* Bouton Submit */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-[90%] mx-auto block py-2.5 bg-terrecuite hover:bg-terrecuite/90 text-white text-sm font-medium rounded-md transition-colors disabled:opacity-50 flex items-center justify-center min-w-[150px]"
              disabled={Object.values(errors).some(e => e) || !selectedOrg || !moduleId || isLoading}
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Création...
                </>
              ) : (
                "Créer le Ticket"
              )}
            </button>
          </div>
        </form>
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
};

export default AddTaskForm;